import { useState } from 'react';

function StockMarketForBeginnersModules() {
  const [openModule, setOpenModule] = useState(null);

  const toggleModule = (index) => {
    setOpenModule(openModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to the Stock Market",
      content: [
        "What is the Stock Market?",
        "Definition of stock markets and exchanges.",
        "The role of the stock market in the economy.",
        "Difference between stock markets and other financial markets.",
        "Why Invest in Stocks?",
        "Potential for capital appreciation and dividends.",
        "Understanding ownership in a company through stocks.",
        "The power of compounding over time."
      ]
    },
    {
      title: "Module 2: How Stocks Work",
      content: [
        "What are Stocks/Equities?",
        "Definition and types of stocks: Common vs. preferred.",
        "How stock prices are determined.",
        "Understanding shareholding and rights (voting, dividends).",
        "Stock Exchanges and Markets",
        "Introduction to major exchanges: NSE, BSE, NYSE, NASDAQ.",
        "How stocks are traded on exchanges."
      ]
    },
    {
      title: "Module 3: Getting Started with Stock Trading",
      content: [
        "Opening a Brokerage Account",
        "Choosing the right broker for your needs.",
        "Steps to open and fund your trading account.",
        "Types of Orders",
        "Market orders, limit orders, stop-loss orders, and their uses.",
        "How to place your first trade.",
        "Stock Ticker Symbols",
        "What they are and how they represent stocks."
      ]
    },
    {
      title: "Module 4: Stock Market Terminology",
      content: [
        "Key Terms Every Beginner Should Know",
        "Bull market, bear market, market capitalization, P/E ratio, etc.",
        "Understanding the difference between stock price and market cap.",
        "Understanding Indexes",
        "What are stock market indices (Nifty, Sensex, S&P 500)?",
        "How indexes help track the overall market performance."
      ]
    },
    {
      title: "Module 5: Basic Investment Strategies",
      content: [
        "Long-Term vs. Short-Term Investing",
        "Benefits of buying and holding stocks for long-term growth.",
        "Short-term trading strategies: day trading and swing trading.",
        "Dividend Investing",
        "What are dividends?",
        "How to build a portfolio that generates passive income.",
        "Growth and Value Investing",
        "Difference between growth and value stocks.",
        "Identifying promising growth or undervalued stocks."
      ]
    },
    {
      title: "Module 6: Understanding Market Trends",
      content: [
        "Bull and Bear Markets",
        "What is a bull market?",
        "How to navigate a bear market and use it to your advantage.",
        "Market Cycles and Trends",
        "Understanding the phases of market cycles.",
        "How to identify trends and make decisions accordingly."
      ]
    },
    {
      title: "Module 7: Risk Management for Beginners",
      content: [
        "What is Investment Risk?",
        "Types of risks: Market risk, credit risk, inflation risk.",
        "How to assess the risk level of an investment.",
        "Diversification",
        "Importance of spreading investments across various asset classes and sectors.",
        "How diversification reduces risk.",
        "Stop-Loss and Take-Profit Strategies",
        "How stop-loss orders protect investments.",
        "Setting take-profit levels for consistent returns."
      ]
    },
    {
      title: "Module 8: Introduction to Stock Analysis",
      content: [
        "Fundamental Analysis Basics",
        "Reading company financials (income statement, balance sheet).",
        "Key financial ratios: P/E, P/B, ROE.",
        "Technical Analysis Basics",
        "Introduction to charts: candlestick, line, and bar charts.",
        "Basic technical indicators (Moving Averages, RSI, MACD)."
      ]
    },
    {
      title: "Module 9: The Psychology of Investing",
      content: [
        "Emotional Impact on Investing",
        "Understanding the role of emotions in decision-making (fear, greed).",
        "The importance of staying calm during market volatility.",
        "Behavioral Biases",
        "Common biases: Confirmation bias, overconfidence, loss aversion.",
        "How to make rational decisions and avoid emotional traps."
      ]
    },
    {
      title: "Module 10: Building a Stock Portfolio",
      content: [
        "The Importance of a Diversified Portfolio",
        "How to mix different stocks, sectors, and asset classes for balance.",
        "Asset allocation based on risk tolerance and financial goals.",
        "Rebalancing Your Portfolio",
        "How and when to adjust your portfolio to keep it aligned with your objectives."
      ]
    },
    {
      title: "Module 11: Understanding Stock Market Regulations",
      content: [
        "Regulatory Bodies",
        "Role of SEBI (Securities and Exchange Board of India) in protecting investors.",
        "Key regulations that govern trading and investing.",
        "Ethical Trading Practices",
        "Importance of following regulations, avoiding insider trading, and ethical considerations."
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="container">
        <h1 className="text-center py-5">Stock Market for Beginners - Our Course Curriculum</h1>
        <div className="row justify-content-center">
          {modules.map((module, index) => (
            <div
              key={index}
              className="col-12 col-md-5 mb-3 d-flex flex-column align-items-center"
              style={{ marginBottom: '10px' }}
            >
              {/* Accordion Heading */}
              <div
                className="w-100 p-3 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: '#f8f9fa',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
                onClick={() => toggleModule(index)}
              >
                <h5 className="m-0">{module.title}</h5>
                <span
                  style={{
                    fontSize: '18px',
                    transform: openModule === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s'
                  }}
                >
                  ▼
                </span>
              </div>

              {/* Accordion Content */}
              {openModule === index && (
                <div
                  className="w-100 p-3"
                  style={{
                    border: '1px solid #ddd',
                    borderTop: 'none',
                    backgroundColor: '#ffffff'
                  }}
                >
                  {module.content.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="d-flex align-items-center mb-2"
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '8px',
                        backgroundColor: '#fdfdfd'
                      }}
                    >
                      <span style={{ color: '#007bff', marginRight: '8px' }}>➤</span>
                      <p className="m-0" style={{ fontSize: '14px', color: '#333' }}>
                        {item}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StockMarketForBeginnersModules;
